const FullTextValidationMessages = {
    FTPhone: 'Please enter a valid phone number (1 555-555-5555)',
    FTMessage: 'Type your message...',
    FTName: 'Please enter a valid name',
    FTEmail: 'Please enter a valid email address',
    FTZipcode: 'Please enter a valid zip code (99501)',
    FTAddress: 'Please enter a valid address'
};
export default FullTextValidationMessages;
